module.exports = __webpack_public_path__ + "static/the-perfect-game-bff33783f4a1a03e70e95b21096ad89a.jpg";